import TextInput from '$tablet-app/src/app/components/TextInput';
import React, { useEffect, useState } from 'react';
import { useWiFiManager } from '../WiFiManager';
import { TouchableOpacity, View } from 'react-native';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { spacing } from '@akin-home/theme';
import { color } from '$tablet-app/src/app/theme';

interface Props {
  onSSIDSelect?: (ssid: string | undefined) => void;
}

export const SSIDDropdown = (props: Props) => {
  const [ssid, setSSID] = useState<string | undefined>();
  const { getCurrentWifiSSID } = useWiFiManager();

  useEffect(() => {
    props.onSSIDSelect?.(ssid);
  }, [props, ssid]);

  const refreshCurrentSSID = async () => {
    const currentSSID = await getCurrentWifiSSID();
    setSSID(currentSSID);
  };

  useEffect(() => {
    refreshCurrentSSID();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <TextInput
        value={ssid ?? ''}
        onChangeText={(text) => setSSID(text)}
        placeholder="Enter WiFi Name"
        style={{ flexGrow: 1 }}
      />
      <TouchableOpacity
        style={{
          padding: spacing[3],
          height: '100%',
          alignItems: 'center',
          flexDirection: 'row',
          borderWidth: 2,
          borderRadius: 10,
          borderColor: color.formElement,
          marginLeft: spacing[2],
        }}
        onPress={() => refreshCurrentSSID()}
      >
        <FontAwesomeIcon
          icon={['far', 'sync']}
          size={25}
          color={color.tertiaryText2}
        />
      </TouchableOpacity>
    </View>
  );
};
